import styled from 'styled-components'

import { formatFileName } from '../lib/formatters'
import { TdsFileNameTooltip } from '../shared/TdsFileNameTooltip'

const Li = styled.li`
  color: ${({ color }) => color};
  font-family: NeueHaasUnica, sans-serif;
  font-size: 15px;
  letter-spacing: .2px;
  line-height: 24px;
  vertical-align: middle;
  margin-bottom: 0px;
`

const Header = styled.span`
  color: ${({ color }) => color};
  font-family: NeueHaasUnica, sans-serif;
  font-size: 15px;
  letter-spacing: .2px;
  line-height: 27px;
  position: relative;
  top: -4px;
  margin-left:9px;
`

const RightText = styled.span`
  float: right;
  padding-right: 40px;
  display:inline-block;
  position: relative;
`

const SVG = styled.svg<{ color: string }>`
  color: ${({ color }) => color};
  width: 18px;
  height: 18px;
  x: 50px;
  focusable: false;
`

type FileNameToolTipProps = {
  color: string
  index: number
  svgColor: string
  href: string
  fileName: string
  fileSize: number
}

//confirm browser compatibility with word-wrap set
const FileNameToolTip = (props: FileNameToolTipProps) => {
  const { color, index, svgColor, href, fileName, fileSize } = props
  return (
    <Li color={color} key={index} className="tlPrivate" >
      <SVG role='figure' color={svgColor}>
        <use href={href} />
      </SVG>
      <Header color={color} >
        <span aria-describedby={fileName}>
          {formatFileName(fileName, undefined)}
          <RightText>{formatFileName(undefined, fileSize)}</RightText>
        </span>
      </Header>
      <TdsFileNameTooltip fileName={fileName} />
    </Li>
  )
}

export { FileNameToolTip }
